// extracted by mini-css-extract-plugin
export default {"page-container":"styles_page-container__yg-g5","content-container":"styles_content-container__UpHK4"};